import axios from 'axios';
import { setAccessToken, setTokenExpiryTime, tokenTypes } from 'utils/AuthUtils/tokenUtils';
// import { getToken } from 'utils/getToken';
// import { refreshTokenFn } from 'utils/refreshToken';
// import axiosRetry from 'axios-retry';
let apiBaseUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  apiBaseUrl = import.meta.env.VITE_BACKEND_ENDPOINT;
} else {
  apiBaseUrl = window.config.apiBaseUrl;
}

// const apiBaseUrl = window.config.apiBaseUrl;
const axiosClient = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

// function to get Cookie
export function getCookie(name: string) {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return value;
    }
  }
  return null;
}

// get the access token from localStorage and add it to the axios config header
axiosClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem(tokenTypes.access) || '';
    const csrfToken = getCookie('csrftoken');

    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
    }
    config.headers = config.headers ?? {};

    if (token) config.headers['Authorization'] = `Bearer ${token}`;

    return config;
  },
  error => Promise.reject(error)
);

// logout user if access token is expired
axiosClient.interceptors.response.use(
  response => response,
  async error => {
    // check if API sends status code of 401 and redirect to login page
    if (error?.response?.status === 401) {
      // set the access token to be null
      setAccessToken('');
      setTokenExpiryTime('');
      // redirect to login page
      window.location.href = '';
    }
    return Promise.reject(error);
  }
);

export { axiosClient };
